export const PriceType = { SELL: 1, RACK: 2, MEMBER: 3 };
Object.freeze(PriceType);
